import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "mt-4" }

import { storeToRefs } from "pinia";

import RoleGuard from "@/components/RoleGuard.vue";
import AlertCard from "@/components/AlertCard.vue";
import TitleHeader from "@/components/TitleHeader.vue";
import TrainingSurveyList from "@/components/surveys/TrainingSurveyList.vue"

import { useGlobalStore, useUserStore } from "@/store";
import { userHasRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'SurveyIndex',
  setup(__props) {

const globalStore = useGlobalStore();
const { user } = storeToRefs(useUserStore());
const hasSmartsurveyAccess = user.value.has_smartsurvey_access;

if (
  userHasRole(user.value.roles, [
    "professional",
    "parent",
    "brick-club-family",
    "certified-facilitator",
    "certified-facilitator-trainee",
    "advanced-facilitator",
    "advanced-facilitator-trainee",
    "facilitator-organisation",
  ])
) {
  globalStore.toast("ERROR", "Unauthorized access");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (_unref(hasSmartsurveyAccess))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(RoleGuard, { roles: ['admin', 'clubs-admin', 'courses-admin', 'trainer-organisation', 'l4a-trainer'] }, {
            default: _withCtx(() => [
              _createVNode(TrainingSurveyList)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (!_unref(user).has_smartsurvey_access)
      ? (_openBlock(), _createBlock(RoleGuard, {
          key: 1,
          roles: ['trainer-organisation', 'l4a-trainer']
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", null, [
              _createVNode(TitleHeader, {
                title: _ctx.$t('training-feedback')
              }, null, 8, ["title"])
            ]),
            _createElementVNode("div", _hoisted_2, [
              _createVNode(AlertCard, {
                type: "warning",
                class: "mt-4"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.$t("trainer-no-smartsurvey-access")), 1)
                  ])
                ]),
                _: 1
              })
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})